import { render, staticRenderFns } from "./m-block-input-copy.vue?vue&type=template&id=47274b5e&scoped=true&lang=pug"
import script from "./m-block-input-copy.vue?vue&type=script&lang=js"
export * from "./m-block-input-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47274b5e",
  null
  
)

export default component.exports